import {GUIDELINE_SECTION, SINGERS, PARTNERS, HIGHLIGHT_MOMENTS} from '../statics/vuon-concert-2025.statics';
import Anniversary from './anniversary/anniversary';
import ConcertBanner from './concert-banner/concert-banner';
import Concert2025Layout from './concert2025-layout/concert2025-layout';
import {CtaButton} from './cta-button/cta-button';
import GuideSection from './guide-section/guide-section';
import HeroBanner from './hero-banner/hero-banner';
import LinearText from './linear-text/linear-text';
import LineupSection from './lineup-section/lineup-section';
import {MerchandiseSection} from './merchandise-section/merchandise-section';
import RegisterSection from './register-section/register-section';
import ShowcaseCard from './showcase-card/showcase-card';
import SingerCard from './singer-card/singer-card';
import {StageLights} from './stage-lights/stage-lights';
import {TimeBlock} from './time-block/time-block';
import TopHeader from './top-header/top-header';
import {VibrantConcertPromo} from './vibrant-concert-promo/vibrant-concert-promo';
import ConcertPartners from './concert-partners/concert-partners';
import {VuonConcert2025Form} from './register-section/components';
import ArtistWithLightEffect from './register-section/components/artist-with-light-effect';
import RegisterSuccess from './register-success/register-success';
import SuperHeroBanner from './SuperHeroBanner/SuperHeroBanner';
import ArtistWithLightEffectV2 from './register-section/components/artist-with-light-effect-v2';
import HighlightMomentsSection from './highlight-moments-section/highlight-moments-section';
import AnniversaryV2 from './anniversary-v2/anniversary-v2';
import OrganizationAndPartnersDesktop from './organization-and-partners/organization-and-partners.desktop';
import OrganizationAndPartnersMobile from './organization-and-partners/organization-and-partners.mobile';
import Organizations from './organization-and-partners/components/organizations';

export {
    Organizations,
    PARTNERS,
    HIGHLIGHT_MOMENTS,
    OrganizationAndPartnersDesktop,
    OrganizationAndPartnersMobile,
    HighlightMomentsSection,
    RegisterSuccess,
    ConcertBanner,
    Concert2025Layout,
    CtaButton,
    LinearText,
    ShowcaseCard,
    SingerCard,
    StageLights,
    TimeBlock,
    TopHeader,
    VibrantConcertPromo,
    HeroBanner,
    LineupSection,
    Anniversary,
    GuideSection,
    RegisterSection,
    GUIDELINE_SECTION,
    SINGERS,
    MerchandiseSection,
    ConcertPartners,
    VuonConcert2025Form,
    ArtistWithLightEffect,
    SuperHeroBanner,
    ArtistWithLightEffectV2,
    AnniversaryV2,
};
